window.addEventListener("pplrAppInitiated", function (e) {
  const input = document.querySelector(".pplr_text");

  if (input) {
    const removeEmojis = (str) => {
      // Regex to remove most emojis
      return str
        .replace(/[\u{1F600}-\u{1F64F}]/gu, "") // Emoticons
        .replace(/[\u{1F300}-\u{1F5FF}]/gu, "") // Misc Symbols and Pictographs
        .replace(/[\u{1F680}-\u{1F6FF}]/gu, "") // Transport and Map
        .replace(/[\u{2600}-\u{26FF}]/gu, "") // Misc symbols
        .replace(/[\u{2700}-\u{27BF}]/gu, "") // Dingbats
        .replace(/[\u{FE00}-\u{FE0F}]/gu, "") // Variation Selectors
        .replace(/[\u{1F900}-\u{1F9FF}]/gu, "") // Supplemental Symbols and Pictographs
        .replace(/[\u{1F1E6}-\u{1F1FF}]/gu, ""); // Flags
    };

    input.addEventListener("input", function () {
      const original = input.value;
      const cleaned = removeEmojis(original);
      if (original !== cleaned) {
        input.value = cleaned;
      }
    });
  }
});
